import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./i18n";
import "./style/main.scss";
import {
  ActivateAccountContainer,
  DealSaverContainer,
  InvoiceContainer,
  LayoutContainer,
  NewsletterUnsubscribeContainer,
  RestorePasswordContainer,
} from "./containers";
import { BackendWeb, PageUrl, SentryReporterWeb } from "@imagine/web-base";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Scripts } from "@imagine/web-base";
import { useAppDispatch, useAppSelector } from "./store/store";
import { UserSelector, UserThunks } from "@imagine/frontend-base";
import {
  BackendProvider,
  RequestStatus,
  SentryReporterProvider,
} from "@imagine/frontend-base";
import { BackendSelector, PhpBackendProvider } from "project";

const sentryReporter = new SentryReporterWeb();
const backend = new BackendWeb(
  BackendSelector.getNodeBackendHost(),
  sentryReporter,
);
const phpBackend = new BackendWeb(
  BackendSelector.getPhpBackendHost(),
  sentryReporter,
);

const App = () => {
  const { i18n } = useTranslation();

  const user = useAppSelector(UserSelector.getUserNotNull);
  const userStatus = useAppSelector(UserSelector.getStatus);
  const dispatch = useAppDispatch();

  const loadData = useCallback(async () => {
    if (userStatus === RequestStatus.IDLE) {
      dispatch(UserThunks.fetchLoggedInUser(phpBackend));
    }
  }, [userStatus, dispatch, user.language]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const loadWebsiteLanguage = useCallback(async () => {
    const location = window.location;
    const language = PageUrl.getLanguageFromUrl(location.pathname);
    let languageCode = "en-GB";
    switch (language) {
      case "da":
        languageCode = "da";
        break;

      default:
    }
    if (i18n.language !== languageCode) {
      await i18n.changeLanguage(languageCode);
    }
  }, [i18n]);

  useEffect(() => {
    loadWebsiteLanguage();
  }, [loadWebsiteLanguage]);

  const loadGoogleAnalytics = () => {
    const allowed = Scripts.googleAnalyticsAllowed();
    if (allowed === undefined) {
      console.warn("Google Analytics consent is not defined");
    } else if (allowed) {
      const key = "G-LCXH7RW2GV";
      Scripts.loadGoogleAnalytics(key);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      loadGoogleAnalytics();
    }, 1000);
  }, []);

  useEffect(() => {
    console.log("Using backend host:", backend.getHost());
    sentryReporter.setName(__APP_NAME__);
    sentryReporter.setVersion(__APP_VERSION__);
  }, []);

  return (
    <SentryReporterProvider reporter={sentryReporter}>
      <BackendProvider backend={backend}>
        <PhpBackendProvider backend={phpBackend}>
          <BrowserRouter basename={"/"}>
            <Routes>
              <Route
                path="/users/reset-password/:resetCode"
                element={<RestorePasswordContainer />}
              ></Route>
              <Route
                path="/:language/users/reset-password/:resetCode"
                element={<RestorePasswordContainer />}
              ></Route>
              <Route
                path="/users/activate/:activationCode"
                element={<ActivateAccountContainer />}
              ></Route>
              <Route
                path="/:language/users/activate/:activationCode"
                element={<ActivateAccountContainer />}
              ></Route>

              <Route
                path="/special-deal/:token"
                element={<DealSaverContainer />}
              ></Route>
              <Route
                path="/newsletter/unsubscribe/:token"
                element={<NewsletterUnsubscribeContainer />}
              ></Route>
              <Route
                path="/:language/newsletter/unsubscribe/:token"
                element={<NewsletterUnsubscribeContainer />}
              ></Route>
              <Route
                path="/pdf/invoice/:invoiceId"
                element={<InvoiceContainer />}
              ></Route>
              <Route path="*" element={<LayoutContainer />}></Route>
            </Routes>
          </BrowserRouter>
        </PhpBackendProvider>
      </BackendProvider>
    </SentryReporterProvider>
  );
};

export default App;
